import { Command } from "./Command";
import {CreateWidgetFromFirebaseNode} from "../components/v3/lib/vue-dom-obj";


export class RemoveCommand extends Command {
    constructor(gridContainer, component) {
        super();
        this._container = gridContainer
        this._removeFirebaseNode = component.fbNode
        this._wrapperComponent = component
        this._widget = CreateWidgetFromFirebaseNode(this._removeFirebaseNode)
    }

    get fbNode() {
        return this._container.fbNode
    }

    get firebaseRef () {
        return this._container.firebaseRef()
    }

    get $children() {
        return this._container.$children
    }

    get $nextTick () {
        return this._container.$nextTick
    }

    get hasChanges () {
        return this._widget !== null || true
    }

    async execute() {
        const elements = document.querySelectorAll(
            `div[data-vnode-id="${this._removeFirebaseNode.data.props.vnodeId}"]`
        )
        if (elements.length > 0) {
            // save to database
            if (this._removeFirebaseNode.children) {
                for (const x of this._removeFirebaseNode.children) {
                    await this._wrapperComponent.firebaseRef().removeNode(x.data.props['.key'])
                }
            }
            this.firebaseRef.removeNode(+this._removeFirebaseNode.data.props['.key']).then(() => {
                this._container.getGrid().removeWidget(elements[0])
                this.fbNode.children = this.fbNode.children.filter(
                    x => x.data.props.vnodeId !== this._removeFirebaseNode.data.props.vnodeId
                )
            })
        }
        if (elements.length > 1) {
            console.log("elements removed: ", elements)
        }
    }

    async unExecute() {
        this.firebaseRef.push(this._widget).then(() => {
            this.fbNode.children.push(this._removeFirebaseNode)
            this.$nextTick(() => {
                const gridStackNodeElement =  this._container.makeWidget(
                    this.$children[this.$children.length - 1]
                )
                gridStackNodeElement.$el.scrollIntoView({
                    behavior: 'smooth',
                })
                if (gridStackNodeElement.resize) {
                    gridStackNodeElement.resize()
                }
            })
        })
    }
}
